import { isAxiosError } from "axios"

import type { SolarShareNotReadyReason } from "./dto/solar-presentation.dto"

const REASONS: readonly SolarShareNotReadyReason[] = [
  `no_active_design`,
  `not_calculated`,
  `out_of_date`,
]

/**
 * The 409 the gateway answers a Solar publish or export with while pricing or
 * savings is not current. Its `error` is the readiness reason, so a command
 * that lost a race explains itself.
 */
export const solarShareBlockedReason = (
  error: unknown,
): SolarShareNotReadyReason | null => {
  if (!isAxiosError(error) || error.response?.status !== 409) {
    return null
  }
  const reason = (error.response.data as { error?: unknown } | undefined)?.error
  return REASONS.find((candidate) => candidate === reason) ?? null
}
